import { useQuery } from '@/hooks/query.hook';
import { PermissionMode } from '@/enums/mode.enum';
import { RolesTable } from '@/components/tables/roles.table';
import { RoleCreateForm } from '@/components/forms/role-create.form';
import { RoleEditForm } from '@/components/forms/role-edit.form';

export default function RoleManagement() {
  const { mode } = useQuery();

  const renderContent = () => {
    switch (mode) {
      case PermissionMode.CREATE:
        return <RoleCreateForm />;
      case PermissionMode.EDIT:
        return <RoleEditForm />;
      default:
        return <RolesTable />;
    }
  };

  return <>{renderContent()}</>;
}
